export default {"src":"/_next/static/media/detailing-logo.b08d5900.svg","height":30,"width":215,"blurWidth":0,"blurHeight":0};